import Model from './Model';

export default class Coupon extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'coupons';
  }
}
